import $ from 'jquery';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';

import lazyLoad from './lazyload';
//Elements
import menuDraggable from '../views/default/elements/menu-draggable/menu-draggable';
import menuHtags from '../views/default/elements/menu-draggable/menu-htags';
import agencyAdvice from '../views/default/elements/agency-advice/agency-advice';
import buttonRsDesp from '../views/default/elements/button-rs-desp/button-rs-desp';
import searcher from '../views/default/elements/searcher/searcher';
import searcher2 from '../views/default/elements/searcher-2/searcher-2';
import btnAboutBlog from '../views/default/elements/btn-about-blog/btn-about-blog';
import tabsAuthor from '../views/default/elements/tabs-author/tabs-author';
import hamburguerIcon from '../views/default/elements/hamburguer-icon/hamburguer-icon';
import menuOptionsDesktop from '../views/default/elements/menu-options-desktop/menu-options-desktop';
import tagsHeader from '../views/default/elements/tags-header/tags-header';
import dropdown from '../views/default/elements/dropdown/dropdown';

//Components
import imageVisor from '../views/default/components/common-components/image-visor/image-visor';
import Ad from '../views/default/components/common-components/ad/ad';
import authorsHeader from '../views/default/components/common-components/authors-header/authors-header';
import theMost from '../views/default/components/board/the-most/the-most';
import header from '../views/default/components/header/header';
import footer from '../views/default/components/footer/footer';
import mssgPartnerAdvice from '../views/default/components/common-components/mssg--partner_advice/mssg--partner_advice';
import menuHeader from '../views/default/components/common-components/menu-header/menu-header';
import vignetteVisor from '../views/default/components/vignette/vignette-visor/vignette-visor';
import vignetteSlider from '../views/default/components/vignette/vignette-slider/vignette-slider';
import newsOnFrontpage from '../views/default/components/news/news-on-frontpage/news-on-frontpage';
import newsKnowMore from '../views/default/components/news/news-know-more/news-know-more';
import sliderBlogs from '../views/default/components/common-components/slider-blogs/slider-blogs';
import sliderBlogsMobile from '../views/default/components/common-components/slider-blogs-mobile/slider-blogs-mobile';
import galleryHeader from '../views/default/components/gallery/gallery-header/gallery-header';
import galleryItem from '../views/default/components/gallery/gallery-item/gallery-item';
import aboutBlog from '../views/default/components/ports/blog/about-blog/about-blog';
import lastPosts from '../views/default/components/minute-by-minute/last-posts/last-posts';
import lastPostsClosed from '../views/default/components/minute-by-minute/last-posts-closed/last-posts-closed';
import timeline from '../views/default/components/minute-by-minute/timeline/timeline';
import opinion from '../views/default/components/board/opinion/opinion';
import branded from '../views/default/components/board/branded-content/branded-content';
import tematic from '../views/default/components/board/tematic-grouper/tematic-grouper';
import minuteByMinute from '../views/default/components/board/minute-by-minute/minute-by-minute';
import photogallery from '../views/default/components/board/gallery/gallery';
import kiosko from '../views/default/components/board/kiosko-net/kiosko-net';
import newsletter from '../views/default/components/board/newsletter/newsletter';
import openingPartner from '../views/default/components/board/content-card/opening-partner/opening-partner';
import rsPanel from '../views/default/components/common-components/buttons-rs-panel/buttons-rs-panel';
import rrssButtons from '../views/default/components/common-components/rrss/rrss';
import blog from '../views/default/pages/automatic-pages/blog/blog';
import automaticPages from '../views/default/pages/automatic-pages/automatic-pages';
import newsSponsoredContent from '../views/default/components/news/news-sponsored-content/news-sponsored-content.js';
import embedDailymotion from '../views/default/components/common-components/embed/embed-dailymotion.js';

// Popup Partner Welcome
import popupPartnerWelcome from '../views/default/components/common-components/popup/partnerWelcome';

// Pages
import author from '../views/default/pages/automatic-pages/author/author';

// To relocate grid components
import customGrid from './custom-grid';

import datalayer from "../views/default/components/common-components/datalayer/datalayer";
import paywall from '../views/default/elements/paywall/paywall';

import widgetOpinary from "../views/default/components/common-components/widget-opinary/widget-opinary";

// Necesitamos que header se ejecute antes del document.ready para evitar flashazos de carga
header();

const init = () => {
  menuDraggable();
  menuHtags();
  agencyAdvice();
  buttonRsDesp();
  searcher();
  searcher2();
  btnAboutBlog();
  tabsAuthor();
  hamburguerIcon();
  menuOptionsDesktop();
  tagsHeader();
  dropdown();
  imageVisor();
  Ad();
  authorsHeader();
  theMost();
  embedDailymotion();
  footer()
  mssgPartnerAdvice();
  menuHeader();
  vignetteVisor();
  vignetteSlider();
  newsOnFrontpage();
  newsKnowMore();
  sliderBlogs();
  sliderBlogsMobile();
  galleryHeader();
  galleryItem();
  aboutBlog();
  lastPosts();
  lastPostsClosed();
  timeline();
  opinion();
  branded();
  openingPartner();
  tematic();
  minuteByMinute();
  photogallery();
  kiosko();
  newsletter();
  rsPanel();
  author();
  customGrid();
  rrssButtons();
  blog();
  automaticPages();
  newsSponsoredContent();
  lazyLoad.update();
  datalayer();
  paywall();
  widgetOpinary();
  popupPartnerWelcome();
};

window.refreshScripts = init;

$(function() {
  init();
});
